import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"eva-icon-btn",style:({ backgroundColor: _vm.color }),attrs:{"fab":"","x-small":"","dark":"","elevation":"0"}},[_c(VIcon,[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }